import { Component, Input, OnInit } from '@angular/core';
import { AdminServiceService } from '../../service/admin-service.service';
import { UiService } from '../../service/ui.service';
import { ProducttChartComponent } from '../productt-chart/productt-chart.component';

@Component({
  selector: 'app-product-stats-card',
  templateUrl: './product-stats-card.component.html',
  styleUrls: ['./product-stats-card.component.scss'],
})
export class ProductStatsCardComponent implements OnInit {
  @Input() product: any = undefined;
  @Input() store = 'pointer';
  public image = '';

  constructor(
    private uiSv: UiService
  ) { }

  ngOnInit() {
  }

  async showProductStat(){
    if(this.store){
      await this.uiSv.createModal(ProducttChartComponent, 
        { product: this.product }, '');
    }
    
  }
}
